<div class="service-detail-page">
    <div class="container">

        <header appFadeInReveal>
            <h1>Terapia Infantil</h1>
            <div class="header-description">
                <p class="lead-text">
                    Acompañar a un niño en su mundo emocional es cuidar su forma de estar en el mundo.
                </p>
                <p>
                    En terapia infantil creo un espacio seguro donde pueda expresarse a su ritmo,
                    comprender lo que le ocurre y desarrollar herramientas para sentirse más tranquilo,
                    seguro y comprendido.
                </p>
                <p>
                    Trabajamos desde el juego, el vínculo y la escucha, siempre en coordinación
                    con la familia y colegio si es necesario.
                </p>
            </div>
            <p class="intro-text">
                ¿Cuándo puede ser útil la terapia infantil?
            </p>
        </header>

        <section appFadeInReveal>
            <p>La terapia puede ayudar a tu hijo si observas alguna de estas señales:</p>
            <ul class="check-list">
                <li>Dificultad para expresar o gestionar emociones.</li>
                <li>Rabietas frecuentes o explosiones emocionales intensas.</li>
                <li>Miedos o ansiedad que interfieren en su día a día.</li>
                <li>Cambios importantes en la conducta.</li>
                <li>Tristeza prolongada o pérdida de interés por actividades.</li>
                <li>Problemas de sueño o alimentación.</li>
                <li>Desafíos en el vínculo familiar o social.</li>
                <li>Dificultades escolares, baja autoestima o inseguridad.</li>
                <li>Situaciones vitales impactantes: separación de los padres, duelo, mudanzas, llegada de un hermano…
                </li>
            </ul>
            <p style="margin-top: 2rem;">
                Si alguna de estas situaciones te resuena, la terapia puede convertirse en un espacio seguro para
                acompañar y comprender lo que tu hijo está viviendo.
            </p>
        </section>

        <section appFadeInReveal>
            <div class="content-block">
                <div class="image">
                    <img src="/services_title_01.webp" alt="Terapia infantil juego simbólico" class="photo--mask"
                        fetchpriority="high">
                </div>
                <div class="text">
                    <h2>Mi enfoque en el trabajo con infancia</h2>
                    <p>
                        Trabajo desde un enfoque respetuoso, cercano y centrado en el mundo interno del niño.
                        Cada niño tiene su propio ritmo y su propia forma de comunicar lo que siente; mi labor es
                        conectar
                        con ese lenguaje y ofrecer una presencia que le permita sentirse seguro.
                    </p>
                    <h3>Basado en el juego</h3>
                    <p>
                        El juego es su forma natural de expresarse. A través del juego simbólico, muñecos,
                        cuentos, dibujo, movimiento o materiales creativos, el niño puede representar lo que no
                        logra poner en palabras.
                    </p>
                </div>
            </div>
        </section>

        <section appFadeInReveal>
            <h2>Acompañamiento a la familia y escuela</h2>
            <p>
                El trabajo no se limita a la consulta. La familia forma parte del proceso, y acompañarla
                es clave para que los cambios se integren en el día a día. Además, considero que es muy
                importante el contacto con el centro escolar para fomentar la coordinación cuando es necesario.
            </p>
        </section>

        <section appFadeInReveal>
            <h2>Beneficios de la terapia infantil</h2>
            <p>Con el acompañamiento adecuado, los niños pueden:</p>
            <ul class="check-list">
                <li>Entender y regular mejor sus emociones.</li>
                <li>Reducir ansiedad, miedos o comportamientos desbordantes.</li>
                <li>Fortalecer su autoestima y seguridad.</li>
                <li>Mejorar la comunicación emocional.</li>
                <li>Desarrollar habilidades sociales.</li>
                <li>Aumentar la confianza en sí mismos.</li>
            </ul>
        </section>

        <section appFadeInReveal>
            <div class="content-block reverse">
                <div class="image">
                    <img src="/services_01.webp" alt="Consulta psicología infantil familia" class="photo--mask">
                </div>
                <div class="text">
                    <h2>El papel de la familia en el proceso</h2>
                    <p>
                        La terapia infantil no solo acompaña al niño; también ofrece un espacio de apoyo para
                        madres, padres y cuidadores.
                    </p>
                    <p>Durante el proceso:</p>
                    <ul class="check-list">
                        <li>Mantengo reuniones periódicas con la familia.</li>
                        <li>Ofrezco orientaciones para comprender mejor lo que está viviendo el niño.</li>
                        <li>Aporto herramientas concretas para casa.</li>
                        <li>Crearemos juntos un entorno seguro y coherente con su bienestar emocional.</li>
                    </ul>
                </div>
            </div>
        </section>

        <div class="cta-container" appFadeInReveal>
            <a routerLink="/contacto" class="btn-primary">Pedir Cita</a>
        </div>

    </div>
</div>